/* global restVar */
import { useState } from '@wordpress/element';
import ReiniciarTicket from './ReiniciarTicket';
import Spinner from '../../shared/components/Spinner';

export default function ValidarBonos( {
	readedBonos,
	isValidatedState,
	ticketValue,
	setInsertedTicket,
	insertTicketImg,
	setInsertTicketImg,
} ) {
	const [ error, setError ] = useState( null );
	const [ isLoading, setIsLoading ] = useState( false );
	const [ ticketId, setTicketId ] = useState( '' );
	const [ isValidated, setIsValidated ] = isValidatedState;

	// Filtramos los bonos y nos quedamos sólo los válidos.
	const validBonos = readedBonos.filter(
		( bono ) => 'valid' === bono.status
	);

	// Añadimos el valor del ticket a todos los bonos válidos.
	validBonos.forEach( ( bono ) => {
		bono.ticketValue = ticketValue;
	} );

	// Enviamos los bonos válidos y el ticket al servidor.
	const handleSubmit = ( e ) => {
		e.preventDefault();
		setIsLoading( true );
		if ( ! ticketId )
			setError( 'Debes introducir un identificador de ticket/factura' );

		fetch( restVar.sciBonosComercioEndpointValidar, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce': restVar.nonce,
			},
			body: JSON.stringify( { validBonos, ticketId } ),
		} )
			.then( ( response ) => {
				if ( ! response.ok ) {
					setError(
						'Ha habido un error al validar los bonos. Por favor, inténtalo de nuevo.'
					);
					return;
				}
				setError( null );
				setIsValidated( true );
				return response.json();
			} )
			.then( ( data ) => {
				// eslint-disable-next-line no-console
				console.log( data );
				setInsertedTicket( data.ticket_id );
			} )
			.finally( () => {
				setIsLoading( false );
			} );
	};

	return (
		<div className="sci-bcl-validar-bonos">
			<p>
				Introduce el identificador de ticket/factura de esta compra para
				poder canjear los bonos.
			</p>
			<form id="send-bonos" onSubmit={ handleSubmit }>
				<input
					type="text"
					id="ticket-id"
					onChange={ ( e ) => setTicketId( e.target.value.trim() ) }
					placeholder="ID del ticket"
					required
				/>
				<input
					className="sci-bcl-btn"
					type="submit"
					value="Validar compra"
				/>
			</form>
			{ error && <p className="sci-bcl-bonos__error">{ error }</p> }
			{ isValidated && (
				<>
					<div className="sci-bcl-bonos__success">
						<p>¡Bonos validados correctamente!</p>
						{ ! insertTicketImg && (
							<button
								className="sci-bcl-btn"
								onClick={ () => setInsertTicketImg( true ) }
							>
								Añadir foto del ticket
							</button>
						) }
					</div>
					<ReiniciarTicket text="Nueva Compra" />
				</>
			) }
			{ isLoading && <Spinner /> }
		</div>
	);
}
